import type { DateTime } from "luxon";
import { useCallback } from "react";
import { handleDownload } from "../../../downloads/utils";
import { backendService } from "../../../services/backend.service";

export type ManagementCenterGraphName =
	| "ppd-comparison"
	| "hppd-comparison"
	| "staff-satisfaction"
	| "shift-fill-rate"
	| "ot-use"
	| "agency-use"
	| "week-active-users";

interface UseManagementCenterDownloadParams {
	graphName: ManagementCenterGraphName;
	startDate: DateTime;
	endDate: DateTime;
}

export const useManagementCenterDownload = ({ graphName, startDate, endDate }: UseManagementCenterDownloadParams) => {
	const download = useCallback(async () => {
		const response = await backendService.downloadManagementCenterMultiGraph({
			graphName,
			startDate,
			endDate,
		});

		const fileName = `${graphName}-${startDate.toFormat("yyyy-MM-dd")}-to-${endDate.toFormat("yyyy-MM-dd")}.csv`;
		handleDownload(response.data, fileName, "text/csv");
	}, [graphName, startDate, endDate]);

	return { download };
};
